import { CANVAS_OBJECT_TYPE_PREFIX } from '../constants';

export const makeApplianceName = (id: string) =>
  `${CANVAS_OBJECT_TYPE_PREFIX.APPLIANCE}_${id}`;
